var map = {
	"./position-1.png": 500,
	"./position-10.png": 86,
	"./position-2.png": 776,
	"./position-3.png": 707,
	"./position-4.png": 543,
	"./position-5.png": 670,
	"./position-6.png": 557,
	"./position-7.png": 96,
	"./position-8.png": 12,
	"./position-9.png": 789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;